export default "__VITE_ASSET__DxIOfFin__"